import { Component, OnInit } from '@angular/core';
import { UserService } from '../shared/services/user.service';
import { SFiTeam } from '../shared/models/user';

@Component({
  selector: 'app-sfiteam',
  templateUrl: './sfiteam.component.html',
  styleUrls: ['./sfiteam.component.css']
})
export class SfiteamComponent implements OnInit {
  sfiTeam: SFiTeam[];

  constructor(private service: UserService,) { }

async  ngOnInit(): Promise<void> {
    await this.service.getSfiTeam().then(userData=>{      
      //userData.sort(function(a, b){return a.id-b.id});
      //console.log("sorted userdata"+userData);
      this.sfiTeam=userData;
      console.log(this.sfiTeam);
    })
  }

}
